import React from 'react';
import { PetalIconImg } from './elements';
import { 
  PageWrapper,
  FlexDiv, 
  Text, 
  Container, 
} from '@Main/elements';
import { Margin, P } from '@helpers';

export const PetalIcon = ({t}) => {
    return (
      <PageWrapper>
        <Container paddingTop='78px' marginLeft='101px' paddingBottom='57px'>
          <P weight='400' size='25px' height='30px'>{t("Petal icon clearspace")}</P>
          <FlexDiv>
            <Text width='308px' paddingBefforeText="45px">
            <p>
              {t("The clearspace rule described above also applies to the petal icon, if it is used separately.")}
            </p>
            </Text>
            <Margin marginLeft='148px' marginTop='40px'>
              <PetalIconImg/>
            </Margin>
          </FlexDiv>
        </Container>
     </PageWrapper>
  );
};
